import AppRouter from "./AppRouter";
import { MenuContextProvider } from '../context/MenuContext'

const App = () => (
  <MenuContextProvider>
    <AppRouter />
  </MenuContextProvider>
)

export default App;
